import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class InsuranceDocument extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static InsuranceDocumentProperties: (
    | {
        property: keyof InsuranceDocument;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof InsuranceDocument;
        type: 'alias';
      }
    | {
        property: keyof InsuranceDocument;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'InsuranceCertificateId', type: 'column', dataType: 'number' },
    { property: 'CompanyVendorFileId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    InsuranceDocument.InsuranceDocumentProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        InsuranceDocument.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        InsuranceDocument.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        InsuranceDocument.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(InsurancePolicyObject: Partial<InsuranceDocument>) {
    super();

    InsuranceDocument.InsuranceDocumentProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = InsurancePolicyObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  InsuranceCertificateId?: number;
  CompanyVendorFileId?: number;
  createdAt?: Date;
  updatedAt?: Date;
}
